import { createContext, useContext } from "react";
import { CartType } from "../../@types/cart";
import { emptyCart } from "./contextHelper";

export const CartContext = createContext<CartType>(emptyCart);
export const getCartContext = (): CartType => useContext(CartContext);
